module.exports = __webpack_public_path__ + "img/cave.e6f44be6.png";